import React from "react";

const Telegram = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_10_48)">
      <path
        d="M14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0ZM19.7236 8.42773C19.1971 8.43715 18.3885 8.71841 14.502 10.335C13.1402 10.9013 10.4182 12.0744 6.33691 13.8525C5.67439 14.116 5.3275 14.3739 5.2959 14.626C5.23549 15.1098 5.93204 15.26 6.80859 15.5449C7.52321 15.7772 8.48438 16.0496 8.98438 16.0605C9.43773 16.0703 9.94431 15.8835 10.5029 15.5C14.3144 12.9272 16.2829 11.6259 16.4082 11.5967C16.4953 11.5769 16.6164 11.5515 16.6982 11.624C16.7801 11.6968 16.7723 11.8351 16.7637 11.8721C16.6943 12.1676 13.1114 15.4255 12.9053 15.6396C12.1176 16.4578 11.2223 16.9583 12.6045 17.8691C13.8005 18.6573 14.4963 19.161 15.7285 19.9688C16.5159 20.4849 17.1334 21.0963 17.9463 21.0215C18.3203 20.9871 18.707 20.6357 18.9033 19.5869C19.3671 17.1076 20.2785 11.7354 20.4893 9.52148C20.5077 9.32753 20.4845 9.07869 20.4658 8.96973C20.4472 8.86078 20.4081 8.70565 20.2666 8.59082C20.0989 8.45471 19.8394 8.42569 19.7236 8.42773Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_10_48">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

Telegram.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Telegram;
